import * as React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

class SocialIcon extends React.Component {
  openWindow = url => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    window.open(
      url,
      "targetWindow",
      `menubar=1,resizable=1,width=${width},height=${height},top=${top},left=${left}`
    );
  };

  render() {
    const currentUrl = window.location.href;
    const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;
    const linkedinShare = `https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}`;
    return (
      <>
        <button onClick={() => this.openWindow(facebookShare)}>
          <FaFacebookF />
        </button>
        {/*<FaInstagram />*/}
        <button onClick={() => this.openWindow(linkedinShare)}>
          <FaLinkedinIn />
        </button>
      </>
    );
  }
}
export default SocialIcon;
